import { FaUserGraduate } from "react-icons/fa";

import { Circle } from "react-feather";

export default [
	{
		id: "profile",
		title: "Миний профайл",
		icon: <FaUserGraduate size={20} />,
		children: [
			{
				id: "teacher-info",
				title: "Хувийн мэдээлэл",
				icon: <Circle size={12} />,
				navLink: "/teacher/personal-information",
			}
		],
	},
];
